import { batch, useDispatch, useSelector } from "react-redux";
import { requestAsync } from "redux-query";
import { exportFunds } from "./exportFunds";
import { language } from "language/default";
import { setBenchmarkMode, setPMIsMode } from "store/grid-settings";
import { removeAllSelectedRow } from "store/grids";
export const useSetBenchmarkMenuItem = (gridId) => {
    const dispatch = useDispatch();
    const mode = useSelector((state) => state.mainGridSettings.setBenchmarkMode);
    return {
        action: () => batch(() => {
            dispatch(setBenchmarkMode(!mode));
            dispatch(removeAllSelectedRow(gridId));
        }),
        hasEmptyIcon: !mode,
        isSelected: mode,
        label: language.en.dashboard.settingsMenu.setBenchmark
    };
};
export const useExportExcel = (request, currentTab) => {
    const dispatch = useDispatch();
    return {
        action: () => batch(() => {
            dispatch(requestAsync(exportFunds(request, currentTab)));
        }),
        hasEmptyIcon: true,
        isSelected: false,
        key: "download-excel",
        label: language.en.grid.excelExport.downloadExcel,
        leftIcon: "export"
    };
};
export const useSetPMIMenuItem = (gridId) => {
    const dispatch = useDispatch();
    const mode = useSelector((state) => state.mainGridSettings.setPMIsMode);
    return {
        action: () => batch(() => {
            dispatch(setPMIsMode(!mode));
            dispatch(removeAllSelectedRow(gridId));
        }),
        hasEmptyIcon: true,
        isSelected: mode,
        key: "setPmis",
        label: language.en.dashboard.settingsMenu.setPMIs
    };
};
